import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { usePriceComparison } from "@/contexts/classified";
export const PriceComparisonLegal = () => {
    const { legalText, pricePerSqm } = usePriceComparison() || {};
    if (!pricePerSqm)
        return null;
    return (_jsx(Box, { typography: "typography.body.12.regular", color: "color.content.light.default", display: "flex", justifyContent: "center", alignItems: "flex-start", children: _jsxs(Box, { children: ["\u00B9 ", legalText, "\u00A0"] }) }));
};
